import styles from './desktop-header.module.css';

import { Box, Button, Flex, Grid } from '@radix-ui/themes';
import LogoLink from '../logo/logo-link';
import ClientThemeProvider from '../../providers/client-theme-provider';
import ExpandableMenuAccountContainer from './expandable-menu-account-container';
import ThemeSwitcher from './theme-switcher';
import { ThemeMode, UserClient } from '@/app/lib/schemas/types/app-types';
import ExpandableMenuContainer from './expandable-menu -container';

interface Props {
  isAtTop: boolean;
  user: UserClient | null;
  isClient: boolean;
  onSubscribe: () => void;
  onLogin: () => void;
  theme: ThemeMode;
  logoHeight: number;
}

export default function DesktopHeader({
  isAtTop,
  user,
  isClient,
  onSubscribe,
  onLogin,
  theme,
  logoHeight
}: Props) {
  return (
    <Box
      display={{ initial: 'none', md: 'block' }}
      className={`${styles.Panel} ${isAtTop ? styles.Top : styles.Scrolled}`}
      width='100vw'
    >
      <Flex
        direction='column'
        justify='center'
        height='100%'
        px='1rem'
      >
        <Grid
          width='100%'
          columns='180px 1fr 220px 36px'
          gap='3'
          align='center'
        >
          <Flex
            align='center'
            gap='4'
          >
            <LogoLink
              theme={theme}
              height={logoHeight}
            />
          </Flex>
          <Box
            width={{ sm: '100%', lg: '80%', xl: '60%' }}
            className={styles.Menu}
          >
            <ExpandableMenuContainer />
          </Box>
          <Flex
            gap='4'
            justify='end'
            align='center'
          >
            {user ? (
              <ClientThemeProvider>
                <ExpandableMenuAccountContainer user={user} />
              </ClientThemeProvider>
            ) : (
              <Flex
                gap='4'
                align='center'
              >
                <Button
                  variant='ghost'
                  onClick={onSubscribe}
                >
                  Оформить подписку
                </Button>
                <Button onClick={onLogin}>Войти</Button>
              </Flex>
            )}
          </Flex>
          {isClient && <ThemeSwitcher />}
        </Grid>
      </Flex>
    </Box>
  );
}
